var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipJarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 8.175c-1.702-.443-2.25-.9-2.25-1.613 0-.817.758-1.387 2.025-1.387 1.065 0 1.598.405 1.793 1.05.09.3.337.525.652.525h.225a.711.711 0 00.675-.952c-.315-.886-1.05-1.62-2.22-1.905v-.518c0-.623-.502-1.125-1.125-1.125S7.5 2.752 7.5 3.375v.495c-1.455.315-2.625 1.26-2.625 2.707 0 1.733 1.433 2.595 3.525 3.098 1.875.45 2.25 1.11 2.25 1.807 0 .518-.367 1.343-2.025 1.343-1.237 0-1.875-.442-2.122-1.072-.113-.293-.368-.503-.676-.503h-.21a.715.715 0 00-.667.975c.428 1.043 1.425 1.658 2.55 1.898v.502c0 .623.502 1.125 1.125 1.125s1.125-.502 1.125-1.125v-.488c1.463-.277 2.625-1.125 2.625-2.662 0-2.13-1.822-2.857-3.525-3.3z"
  })));
}
export default SvgTipJarIcon;